var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.426 4.731h-.051a2.49 2.49 0 01-1.02-.225L9.458 11.88 4.537 8.694c-.21.366-.517.67-.888.882a2.48 2.48 0 01-1.222.324H2.25l2.039 8.631h10.086l.05-13.8z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.374 18.522h5.325v-5.327c0-.106.045-.207.122-.282a.417.417 0 01.29-.116h5.729l.68-2.9a2.473 2.473 0 01-1.246-.357 2.388 2.388 0 01-.879-.931l-4.988 3.264-3.915-7.41c-.331.17-.7.263-1.074.269l-.044 13.79z",
    fill: "#FFB24D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.537 8.695c.207-.353.316-.753.316-1.16 0-.459-.137-.91-.395-1.294A2.411 2.411 0 003.4 5.368a2.485 2.485 0 00-1.376-.166 2.452 2.452 0 00-1.245.595A2.353 2.353 0 00.072 6.96c-.114.446-.092.915.063 1.35.155.434.436.815.81 1.095.374.281.824.45 1.294.485h.177a2.48 2.48 0 001.227-.317 2.4 2.4 0 00.894-.878zm9.837-3.96h.051a2.426 2.426 0 001.067-.272 2.391 2.391 0 001.093-1.12 2.308 2.308 0 00.148-1.54 2.359 2.359 0 00-.86-1.299A2.467 2.467 0 0014.375 0v4.735z",
    fill: "#FF9A00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.374 0c-.644 0-1.261.25-1.716.692a2.334 2.334 0 00-.71 1.672c0 .627.255 1.228.71 1.672a2.46 2.46 0 001.716.692V0z",
    fill: "#FFB24D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.506 9.896h.055c.7-.007 1.37-.284 1.861-.77a2.548 2.548 0 00.762-1.825 2.55 2.55 0 00-.781-1.818 2.687 2.687 0 00-1.87-.752c-.7 0-1.372.27-1.869.752a2.55 2.55 0 00-.781 1.818c-.004.682.27 1.339.762 1.825.491.486 1.16.763 1.861.77zm-6.804 8.626h-5.328v4.662h5.328v-4.662z",
    fill: "#FF9A00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.278 18.522v3.94c.003.187.08.366.215.5.134.133.317.21.51.215h9.371v-4.655H4.278z",
    fill: "#FFB24D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.966 23.442a.406.406 0 00-.151-.18.422.422 0 00-.23-.069H27.09v-9.999a.396.396 0 00-.122-.281.417.417 0 00-.289-.116H20.11a.417.417 0 00-.29.116.396.396 0 00-.12.281v10h-4.514a.421.421 0 00-.373.248.388.388 0 00.088.433l8.19 8.006a.409.409 0 00.29.119.416.416 0 00.29-.119l8.214-8.006a.394.394 0 00.081-.433z",
    fill: "#5560FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDown);
export default __webpack_public_path__ + "static/media/Icon-down.3ef0933f.svg";
export { ForwardRef as ReactComponent };